import api from 'utils/api';

export const fetchReferrersApi = (params) =>
	api.get('/admin/referrers', { params });

export const approveReferrerApi = (id) =>
	api.put(`/admin/referrers/${id}/approve`);

export const deactivateReferrerApi = (id) =>
	api.put(`/admin/referrers/${id}/deactivate`);
